import { postPdf } from './requests';

export const postPdfSaga = async ({ action }) => {
  const data = await postPdf(action.payload);
  return data;
};
